<template>
  <el-date-picker
    v-model="val"
    type="daterange"
    :size="size"
    :disabled="disabled"
    :clearable="clearable"
    value-format="yyyy-MM-dd HH:mm:ss"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    :default-time="['00:00:00', '23:59:59']"
    @change="changeHandle"
  >
  </el-date-picker>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: Array,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: "small",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: null,
    };
  },
  watch: {
    value: {
      handler: function (value) {
        this.val = value;
      },
    },
  },
  methods: {
    changeHandle(value) {
      this.val = value;
      this.$emit("change", this.val);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/business/DateRangePicker.vue